import { render, staticRenderFns } from "./areachart_component.vue?vue&type=template&id=ff89697e"
import script from "./areachart_component.vue?vue&type=script&lang=js"
export * from "./areachart_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports